import { render, staticRenderFns } from "./now.vue?vue&type=template&id=bb6d372e&scoped=true&"
import script from "./now.vue?vue&type=script&lang=js&"
export * from "./now.vue?vue&type=script&lang=js&"
import style0 from "./now.vue?vue&type=style&index=0&id=bb6d372e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6d372e",
  null
  
)

export default component.exports